'use es6';

import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { EVENTS } from '../../utils/usageTracker';
import { useTracker } from '../../utils/hooks/useTracker';
import { useShowDialog } from '../../dialog/ducks';
import useDeleteDashboardProblem from './useDeleteDashboardProblem';
import { DELETE_DASHBOARD_DIALOG } from '../../dialog/dialogTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteDashboardButton = props => {
  const {
    dashboard,
    onDelete,
    trackAction,
    appUsageTracker
  } = props;
  const showDialog = useShowDialog();
  const usageTracker = useTracker(appUsageTracker);
  const {
    problem,
    disabledMessage
  } = useDeleteDashboardProblem({
    dashboard
  });
  const handleDeleteDashboardClick = e => {
    e.preventDefault();
    if (usageTracker) {
      usageTracker.track(EVENTS.clickDeleteActionNew, {
        actionType: 'edit',
        action: 'delete',
        step: 'start',
        assetType: 'dashboard'
      });
    }
    showDialog({
      dialogType: DELETE_DASHBOARD_DIALOG,
      dialogProps: {
        dashboardsToDelete: ImmutableSet([dashboard]),
        onDelete,
        trackAction,
        appUsageTracker
      }
    });
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !problem,
    title: disabledMessage,
    placement: "left",
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": problem !== 'LOADING' && 'dashboard-action-delete-dashboard',
      use: "link",
      disabled: !!problem,
      onClick: handleDeleteDashboardClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.deleteDashboard.name"
      })
    })
  }, "delete");
};
DeleteDashboardButton.propTypes = {
  dashboard: PropTypes.instanceOf(ImmutableMap).isRequired,
  onDelete: PropTypes.func.isRequired,
  trackClick: PropTypes.func.isRequired,
  appUsageTracker: PropTypes.object.isRequired,
  trackAction: PropTypes.func.isRequired
};
export default DeleteDashboardButton;